import type { WorkHistoryFormData } from "./hooks/edit-work-history";

import styles from "./views/styles.module.scss";

export const INITIAL_WORK_HISTORY_VALUES: Partial<WorkHistoryFormData> = {
  description: undefined,
  id: undefined,
  is_currently_working: false,
  month_from: undefined,
  month_to: undefined,
  new_company: undefined,
  title: undefined,
  year_from: undefined,
  year_to: undefined,
};

export const MODULE_EDIT_MODAL_PROPERTIES = {
  closeButton: true,
  closeButtonProps: {
    variant: "tertiary",
    size: "x-small",
  },
  keepOnBackdropClick: true,
  className: styles.modal,
} as const;

export const TALENT_LOCATION = {
  talent_listing: "talent_listing",
  talent_search: "talent_search",
  legacy_talent_search: "legacy_talent_search",
} as const;

export const ADD_ANOTHER_ITEM = "ADD_ANOTHER_ITEM";

export const MAX_YEARS_OF_EXPERIENCE = 99;
export const MIN_YEARS_OF_EXPERIENCE = 0;
